import axios from "axios";
import { BASE_URL } from "./constants";

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 40000,
});

instance.interceptors.request.use((config) => {
  // params might be undefined if no params are already set
  config.params = config.params || {};
  // config.params['lang'] = Localizer.getInstance().intl.locale;

  return config;
});

export default instance;
